import React from 'react'

export interface EditButtonLinkProps {
  to?: string
  label: string | React.ReactElement
}

export const EditButtonLink: React.FC<EditButtonLinkProps> = ({ to, label }) => (
  <a className='button icon-button pro-rounded pro-orange-400 pro-closest-shadow supplier-profile-button' href={to}>
    {label} <i className='fas fa-square-pen' aria-hidden />
  </a>
)
